import { libraryManagedConfig } from '../../../../config';
import { http } from '../../../../api/axios';

type SortingSettingPayload = {
    title: string;
    sorting: string;
    productGroupId: string;
};

export const saveLibraryManagedProductGroupSortBy = async (props: SortingSettingPayload) => {
    const { productGroupId, ...data } = props;

    return http.put(libraryManagedConfig().endpointProductGroupSortAndTitle, data, {
        pathParams: { productGroupId }
    });
};
